export const CANADA_TRANSLATIONS = {
  text: {
    web_title: 'SMARTZ™ DASHBOARD',
    authentication: 'Authentication',
    username: 'Username',
    password: 'Password',
    sign_in: 'Sign In',
    username_required: 'Username is required',
    password_required: 'Password is required',
    invalid_credential: 'Incorrect username or password',
    forgot_password: 'Forgot Password',
    change: 'Change',
    well_being: 'Well Being',
    warnings: 'Warnings',
    no_patients_to_change: 'No Patients to change',
    no_patients: 'No Patients',
    logout: 'Logout',
    lost_connection: 'Lost connection with Smartz™ cloud',
    check_connection: 'Please check your internet connection',
    trying_to_reconnect: 'Trying to reconnect',
    pad_time: 'Time in pad',
    red_time: 'Time in red',
    position: 'Position',
    time: 'Time',
    time_in_position: 'Time in position',
    sitting: 'Sitting',
    standing: 'Standing',
    left: 'Left',
    right: 'Right',
    lying: 'Lying',
    unknown: 'Unknown',
    wet_surface: 'Wet Surface',
    out_of_range: 'Out of Range',
    low_battery: 'Low Battery',
    disconnected: 'Disconnected',
    unexpected_problem: 'Unexpected Problem',
    ok: 'Ok',
    change_soon: 'Change Soon',
    change_pad: 'Change Pad',
    languages: 'Languages',
    dashboard: 'DASHBOARD',
    pad_fill_profile: 'Pad Fill Profile',
    goal: 'GOALS',
    report: 'REPORT',
    manage: 'MANAGE',
    individual: 'Individual',
    group: 'Group',
    action_required: 'ACTION REQUIRED',
    monitor: 'MONITOR',
    pod_unclipped: 'pod unclipped',
    check_patient: 'check Patient',
    check_pad: 'check pad',
    check_time_in_pad: 'check time in pad',
    check_position: 'check position',
    check_temperture: 'check temperature',
    check_pad_fill_profile: 'CHECK PAD FILL PROFILE',
    instructions: 'instructions',
    time_in_pos: 'time in pos',
    pad_capacity: 'pad capacity',
    time_in_pad: 'time in pad',
    ambient: 'ambient',
    time_at_temp: 'time at temp',
    pad_wet: 'PAD WET',
    pad_dry: 'PAD DRY',
    daily_pad_fill: 'Daily Pad Fill',
    seven_day_trend: 'Seven-Day Trend',
    daytime: 'Daytime',
    nighttime: 'Nightime',
    volume_in_pad: 'Volume in pad',
    pad_fill_summary: 'PAD FILL SUMMARY',
    daily_average: 'Daily Average',
    today: 'Today',
    capacity: 'Capacity',
    pads_used: 'pads used',
    per_day: 'per day',
    average: 'average',
    leakage_detected: 'Leakage detected',
    times: 'times',
    pad_cycles: 'Pad cycles',
    time_in_a_pos: 'Time in a pos',
    max_time_in_a_pos: 'Maximum time in position',
    re_positioning: 'Re-positioning',
    time_day: 'time/day',
    temperature: 'Temperature',
    typical_temp: 'Typical temperature',
    temp_range: 'Temperature range',
    charts: 'CHARTS',
    pad_fill_profile_for_7_days: 'Pad Fill Profile – Seven-Day Trend',
    daily_total: 'Daily Total',
    accuracy: 'accuracy',
    last_24_hours: '24 Hours from selected date',
    volume_voided_in_pad: 'volume voided in pad',
    body: 'Body',
    wetness_usage: 'wetness/usage',
    environment_body: 'surrounding temperature',
    activity: 'Activity',
    lift_style: 'lift style',
    skin_care: 'Skin Care',
    skin_care_management: 'skin care management',
    workflow: 'Workflow',
    workflow_efficiency: 'workflow efficiency',
    set_maximum_voiding_volume_into_pad: 'Set maximum voiding volume into pad',
    less_void: 'LESS VOID',
    more_void: 'MORE VOID',
    day: 'DAY',
    night: 'NIGHT',
    day_time: 'Day Time',
    night_time: 'Night Time',
    average_period: 'Average Period',
    default: 'DEFAULT',
    desire_position: 'Time in Position',
    time_in_a_position: 'Time in a position',
    desire_temperature: 'Surrounding Pod Temperature',
    coloer: 'COLDER',
    hotter: 'HOTTER',
    desire_skin_care: 'Skin Care',
    off: 'OFF',
    standard_care: 'STANDARD CARE',
    extra_care: 'EXTRA CARE',
    more_time_in_wet_pad: 'MORE TIME IN WET PAD',
    more_time_in_a_pos: 'MORE TIME IN A POS',
    less_time_in_wet_pad: 'LESS TIME IN WET PAD',
    less_time_in_a_pos: 'LESS TIME IN A POS',
    override: 'This goal will override pad and body goals',
    check_pod: 'check pod',
    check_pod_and_reclip: 'check pod and re-clip',
    lost_connect: 'Lost Connection',
    voids_into_pad_hours: 'Voids into pad in 96 hours',
    chart_date: 'Chart Date',
    fullscreen: 'Full Screen',
    normalscreen: 'Normal Screen',
    void_chart: 'Voiding Chart',
    voids_into_pad: 'voids into pad',
    pad_fill_trend: 'pad fill trend',
    legend: 'LEGEND',
    new_pad: 'new pad',
    void_in_pad: 'void in pad',
    share: 'Share',
    print: 'Print',
    position_profile: 'Position Profile',
    body_position: 'Body Position',
    body_positions_over_96_hours: 'Body Positions over 96 hours',
    lying_on_back: 'Lying - on back',
    lying_on_front: 'Lying - on front',
    lying_left_side: 'Lying - left side',
    lying_right_side: 'Lying - right side',
    standing_walking: 'Standing/Walking',
    stats: 'stats',
    pad_used: 'pad_used',
    max: 'max',
    surrounding_temperature: 'SURROUNDING TEMPERATURE',
    temp: 'temp',
    avg: 'avg',
    name: 'Name',
    provider: 'Provider',
    purpose: 'Purpose',
    expiry: 'Expiry',
    type: 'Type',
    frequently_asked_questions: 'Frequently Asked Questions',
    information_for_use: 'Information for Use',
    data_privacy: 'Data Privacy',
    eula: 'EULA',
    about: 'About',
    settings: 'Settings',
    save: 'Save',
    version: 'version',
    support: 'support',
    close: 'Close',
    copyright:
      'Copyright (C) 2022 Smartz Operations Limited. All Rights Reserved',
    smartz_devices: 'Smartz™ Devices',
    monitor_smartz_device_operation: 'monitor Smartz™ device operation',
    last_seen: 'Last seen',
    battery: 'Battery',
    ago: 'ago',
    date_rate: 'Date Rate',
    online: 'Online',
    singnal: 'Signal',
    temperature_goal: 'TEMPERATURE GOAL',
    data_privacy_desc: 'manage consent and personal data',
    organisation: 'ORGANIZATION',
    organisation_desc: 'manage group settings',
    my_account: 'My Account',
    my_account_desc: 'manage account settings',
    consent: 'Consent',
    marketing_comm: 'Marketing, Communications & Promotions',
    consent_desc:
      'Pad manufactures and distributors may use personal data for marketing and promotions. The User(s) account, if any, associated with this Patient may be emailed from time-to-time. In this case, user email may be shared to 3rd parties.',
    data_management: 'Data Management',
    Permanently_delete_account: 'Permanently delete this User account',
    permanently_delete_client: 'Permanently delete this client',
    data_management_desc:
      'The account will no longer be available, and all data in the account will be permanently deleted.',
    how_can_i_export: 'How can I export and back up my account data?',
    save_preference: 'SAVE PREFERENCE',
    delete_account_data: 'DELETE ACCOUNT & DATA',
    date_time_settings: 'Date & Time Settings',
    morning_time: 'Morning time',
    night_time_label: 'Night time',
    time_format: 'Time format',
    date_format: 'Date format',
    goal_text: 'goal',
    day_goal: 'day goal',
    night_goal: 'night goal',
    check_battery: 'CHECK BATTERY',
    reminders: 'reminders',
    update_data_privacy_consent: 'Update Data Privacy Consent',
    update: 'Update',
    user: 'User',
    last_updated: 'Last Updated',
    action: 'Action',
    delete_confirm: 'Are you sure you want to delete it?',
    cancel: 'Cancel',
    lost_internet_connection: 'LOST INTERNET CONNECTION',
    check_setting: 'Please check your Internet settings and connections',
    authentication_required: 'Authentication Required',
    account_details_have_changed: 'Account details have changed',
    date: 'Date',
    no_pod_assigned: 'no pod assigned',
    monitoring_is_not:
      'Monitoring is not available because a Smartz™ pod has not been assigned to ',
    assign_a_pod: 'Assign a pod to',
    on_the_smartz_monitor_app:
      'on the Smartz™ Monitoring app to activate monitoring.',
    see: 'See',
    delete: 'delete',
    keep_in_mind_delete_data:
      'Please keep in mind that deleting User account and personal data is permanent.',
    you_able_to_delete_data: 'You are about to delete',
    account_and_data: 'account and data',
    this: 'this',
    average_time_in_pad: 'Average time in pad',
    average_time_in_position: 'Average time in position',
    repositioning_24h: 'Repositioning 24 h',
    last_7_day_period: 'Last 7 day period',
    admin: 'ADMIN',
    administraive_settings: 'administraive settings',
    group_data_rentenion: 'Group Data Retention',
    maximum_inactivity_data_retention_period:
      'Maximum inactivity data retention period',
    group_data_rentenion_desc:
      'Personal data of all Users and Patients within this group will be removed if the inactivity period has been reached.',
    data_rentenion_detail:
      'Condition for inactivity is as follows:<br>- Pod is not assigned to Patient for specified period of time<br>- Pod is assigned to Patient but not transmitting data to Smartz™ apps for specified period of time<br>- User has not signed in for specified period of time',
    months: 'months',
    user_roles: 'User Roles',
    users: 'Users',
    role: 'Role',
    filter_by_group_or_users: 'filter by group or users',
    urine_conversion_feature: 'Urine Conversion Feature',
    use_urine_transform: 'Use Urine Transform',
    system_data_rentenion: 'System Data Retention',
    system_data_rentenion_desc:
      'Personal data of all Users and Patients within this system will be removed if the inactivity period has been reached.',
    reset_password: 'Reset Password',
    new_password: 'New Password',
    confirm_password: 'Confirm Password',
    password_inconsistent: 'The password is inconsistent',
    edit: 'edit',
    edit_roles: 'Edit Roles',
    available_roles: 'Available roles',
    assigned_roles: 'Assigned roles',
    role_list: 'Role List',
    role_name: 'Role Name',
    role_permissions: 'Role Permissions',
    level_1_module: 'Level 1 module',
    level_2_module: 'Level 2 module',
    permissions: 'Permissions',
    add_role: 'ADD ROLE',
    roles: 'roles',
    role_settings: 'role settings',
    edit_role: 'Edit Role',
    account_take_effect: 'The update will be take effect after re-login.',
    algorithms: 'Algorithms',
    delete_role_confirm: 'Deletion of role is permanent.',
    //translate permissions list
    'Dashboard Module': 'Dashboard Module',
    'Charts Module': 'Charts Module',
    'Goals Module': 'Goals Module',
    'Manage Module': 'Manage Module',
    Group: 'Group',
    Individual: 'Individual',
    'Voiding Chart': 'Voiding Chart',
    'Pad Fill Profile Chart': 'Pad Fill Profile Chart',
    'Body Position Chart': 'Body Position Chart',
    'Smartz Devices Chart': 'Smartz™ Devices Chart',
    'Pad Fill Profile': 'Pad Fill Profile',
    'Skin Care': 'Skin Care',
    Position: 'Position',
    Temperature: 'Temperature',
    Admin: 'Admin',
    'My Account': 'My Account',
    Role: 'Role',
    Organisation: 'Organization',
    'Data Privacy': 'Data Privacy',
    View: 'View',
    Share: 'Share',
    Print: 'Print',
    Save: 'Save',
    'Reset Password': 'Reset Password',
    Delete: 'Delete',
    Add: 'Add',
    Edit: 'Edit',
    Fall: 'Fall',
    //end translate permissions list
    check_fall: 'CHECK FALL',
    position_goal_not_allow_off:
      "Position goal can't be turned OFF whilst Falls goal is turned ON to improve safety.",
    falls: 'Falls',
    falls_detection_and_notification: 'falls detection and notification',
    falls_detection: 'Falls Detection',
    detect_falls: 'Detect Falls',
    on: 'ON',
    position_goal: 'Position Goal',
    has_been_turn_on:
      'has been turned ON to complement Falls Detection and improve safety.',
    last_fall: 'Last Fall',
    last_week: 'last week',
    three_months: '3 months',
    time_to_change: 'Time to Change',
    sent_successfully: 'Sent Successfully',
    sent_failed: 'Sent Failed',
    send_email: 'Send Email',
    send: 'Send',
    add_email: 'Add Email',
    saved_successfully: 'Saved Successfully',
    saved_failed: 'Saved Failed',
    deleted_successfully: 'Deleted Successfully',
    deleted_failed: 'Deleted Failed',
    email: 'Email',
    please_enter_email_address: 'Please enter Email address',
    please_enter_the_correct_email_address:
      'Please enter the correct Email address',
    time_in_a_pad_goal: 'TIME IN A PAD GOAL',
    time_goal: 'TIME GOAL',
    body_temperature: 'Body Temperature',
    upper_goal_limit: 'upper goal limit',
    lower_goal_limit: 'lower goal limit',
    time_of_fall: 'time of fall',
    heart_rate: 'Heart Rate',
    max_heart_rate: 'Max Heart Rate',
    min_heart_rate: 'Min Heart Rate',
    average_heart_rate: 'Average Heart Rate',
    oximetry: 'Oximetry',
    blood_o2_saturation: 'blood o2 saturation',
    min_oximetry: 'Min Oximetry',
    max_oximetry: 'Max Oximetry',
    average_oximetry: 'Average Oximetry',
    respiration: 'Respiration',
    breathing_pattern: 'breathing pattern',
    breath: 'breath',
    respiration_vs_oximetry: 'Respiration vs Oximetry',
    min_respiration: 'Min Respiration',
    max_respiration: 'Max Respiration',
    average_respiration: 'Average Respiration',
    balance: 'Balance',
    falls_and_balance: 'falls and balance',
    loss_of_balance_events: 'Loss Of Balance Events',
    sudden_changes_in_body_orientation: 'Sudden Changes in Body Orientation',
    goal_limit: 'goal limit',
    last_event_exceeding_goal: 'Last Event Exceeding Goal',
    balance_loss_events: 'Balance loss events',
    per_7_days: 'per 7 days',
    body_lean_over_7_days: 'Body Lean over 7 days',
    chart_shows_tendency:
      'Chart shows the tendency of the body to lean in a particular direction whilst moving',
    lean_forward: 'Lean forward',
    backwards: 'backwards',
    forward: 'forward',
    vitals: 'VITALS',
    vitals_signs: 'VITAL SIGNS',
    spo2: 'SPO2',
    pulse: 'Pulse',
    abdominal_movement: 'Abdominal Movement',
    min: 'min',
    attach_the_pod:
      'Attach the pod only when the pad is already on the Patient. Failing to follow this instruction could result in a fall being falsely detected due to the movement and handling of the pad before it is applied to the Patient.',
    body_positions_analysis: 'Body Positions Analysis',
    repositioning: 'Repositioning',
    stayed_in_one_position: 'stayed in one position',
    change_in_position: 'change in position',
    no_pod_data: 'no pod data',
    possible_intervention: 'Possible intervention',
    body_position_goal: 'BODY POSITION GOAL',
    tap_to_setup_body_position_goals: 'tap to setup body position goals',
    time_blocks_greater_than: 'time blocks greater than',
    will_be_highlighted: 'will be highlighted',
    chart_filters: 'CHART FILTERS',
    tap_to_show: 'tap to show',
    tap_to_hide: 'tap to hide',
    notifications: 'Notifications',
    time_to_reposition: 'Time-to-Reposition',
    hour: 'hour',
    hours: 'hours',
    minute: 'minute',
    minutes: 'minutes',
    sensor_disconnected: 'sensor disconnected',
    from: 'FROM',
    to: 'TO',
    quick_start_guide: 'Quick Start Guide',
    wet_outside: 'Wetness Outside Pad',
    attend_fall: 'ATTEND FALL',
    reclip_pod: 'RECLIP POD',
    change_position: 'CHANGE POSITION',
    replace_battery: 'REPLACE BATTERY',
    allowed_time_exceeded: 'Allowed time exceeded',
    wetness_outside: 'Wetness outside',
    analysing_pad: 'Analyzing Pad',
    pad_not_selected: 'Pad not selected',
    silence: 'Silence',
    silence_confirm_box_title: 'Silence Falls',
    silence_confirm_box_content:
      'Silencing the falls notification will remove it from the group dashboard. Would you like to proceed? ',
    yes: 'YES',
    no: 'NO',
    pad_status: 'PAD STATUS',
    check_pad_fill: 'CHECK PAD FILL',
    patient_profile: 'PATIENT PROFILE',
    periods: 'Periods',
    products: 'Products',
    active: 'active',
    manage_user_profile: 'Manage user profile',
    sign_out: 'Sign out',
    view: 'View',
    groups: 'groups',
    groups_in_view: 'Groups in view',
    total_daily_profile: 'Total daily profile',
    day_profile: 'Day profile',
    night_profile: 'Night profile',
    pad_fill_profile_goal: 'PAD FILL PROFILE GOAL',
    tap_to_setup_pad_fill_profile_goals: 'tap to setup pad fill profile goals',
    insufficient_data: 'Insufficient data',
    last_7_days: 'Last 7 days',
    pad_removed: 'pad removed',
    view_groups: 'View group(s)',
    minimum_voiding_into_pad: 'Minimum Voiding into Pad',
    Monday: 'Monday',
    Tuesday: 'Tuesday',
    Wednesday: 'Wednesday',
    Thursday: 'Thursday',
    Friday: 'Friday',
    Saturday: 'Saturday',
    Sunday: 'Sunday',
    disconnected_desc: 'waiting for the pod to be re-clipped onto pad...',
    pod_unclipped_desc: 'waiting for pod to come back into range...',
    password_policy: 'Password Policy',
    position_chart: 'Position Chart',
    hi_everyone: 'Hi everyone',
    voiding_chart_email_content:
      'The emailed Voiding Chart is ready for you to review.',
    pad_fill_profile_chart_email_content:
      'The emailed Pad Fill Profile Chart is ready for you to review.',
    position_chart_email_content:
      'The emailed Position Chart is ready for you to review.',
    temperature_chart_email_content:
      'The emailed Temperature Chart is ready for you to review.',
    heare_rate_chart_email_content:
      'The emailed Heart Rate Chart is ready for you to review.',
    oximtry_chart_email_content:
      'The emailed Oximetry Chart is ready for you to review.',
    respiration_chart_email_content:
      'The emailed Respiration Chart is ready for you to review.',
    balance_chart_email_content:
      'The emailed Balance Chart is ready for you to review.',
    smartz_chart_email_content:
      'The emailed Smartz™ Chart is ready for you to review.',
    best_regards: 'Best Regards',
    the_simavita_team: 'The Smartz Operations Team',
    days: 'days',
    weeks: 'weeks',
    years: 'years',
    reset_all_users_passwords: "Reset All Users' Passwords",
    reset_all_passwords: 'Reset All Passwords',
    reset: 'Reset',
    change_password: 'Change Password',
    old_password: 'Old Password',
    lowercase: 'Lowercase',
    uppdercase: 'Uppercase',
    number: 'Number',
    please_select: 'Please select',
    loading_chart: 'Loading Chart',
    please_wait: 'Please wait...',
    edit_user: 'Edit User',
    add_user: 'Add User',
    edit_group: 'Edit Group',
    add_group: 'Add Group',
    group_name: 'Group Name',
    group_name_required: 'Group name is required',
    patients: 'Patients',
    manage_user_account: 'manage user account',
    filter_by_group_name: 'filter by group name',
    delete_group_warning:
      'Please keep in mind that deleting group is permanent.',
    delete_patient_warning:
      'Deletion of Patient and personal data is permanent.',
    pod_mac: 'Pod Mac',
    pod_serial_number: 'Pod Serial Number',
    add_patient: 'Add Patient',
    edit_patient: 'Edit Patient',
    alias: 'Alias',
    alias_required: 'Alias is required',
    pod_mac_required: 'Pod mac is required',
    pod_serial_number_required: 'Pod Serial Number is required',
    please_enter_capital_letters_and_numbers:
      'Please enter capital letters and numbers',
    select_date_range: 'Select date range',
    start_time: 'start time',
    end_time: 'end time',
    select_groups_to_collate: 'Select group(s) to collate',
    all_groups: 'All groups',
    export_report: 'Export Report',
    export_csv: 'Export CSV',
    reports: 'Reports',
    please_complete_form: 'Please complete the form',
    nodes: 'Nodes',
    network_map: 'Network Map',
    network_utilisation: 'Network Utilisation',
    notify_me_when_nodes_offline: 'Notify me when node(s) arre offline',
    zoom_in_chart: 'Enable zoom in chart',
    latency: 'Latency',
    lan: 'LAN',
    wifi_infrastructure: 'Wi-Fi Infrastructure',
    pods: 'Pods',
    data: 'Data',
    packet_less: 'Packet less',
    secondary_connection: 'Secondary Connection',
    rssi: 'RSSI',
    no_nodes: 'No Nodes',
    share_code: 'Share Code',
    active_patients: 'Active Patients',
    archived_patients: 'Archived Patients',
    archive: 'archive',
    restore: 'restore',
    are_you_sure: 'Are you sure?',
    you_about_to_archive: `You are about to archive`,
    default_group_not_delete: 'The default group cannot be deleted',
    patients_belong_to: 'Patients belonging to',
    move: 'Move',
    warning: 'Warning',
    add_node: 'Add Node',
    edit_node: 'Edit Node',
    room_name: 'Room Name',
    mac_address: 'MAC Address',
    delete_node_warning: 'Deletion of node is permanent. ',
    mac_address_required: 'MAC Address is required',
    room_name_required: 'Room Name is required',
    mac_address_format_warning:
      'The MAC address format entered is incorrect. Please enter it in the form of XX:XX:XX:XX:XX:XX',
    node_management: 'Node Management',
    time_period: 'Time Period',
    manufacturer: 'Manufacturer',
    product: 'Product',
    please_select_time_period: 'Please select time period',
    please_select_manufacturer: 'Please select manufacturer',
    please_select_product: 'Please select product',
    no_data: 'No data',
    please_select_manufacturer_first: 'Please select manufacturer first',
    details: 'Details',
    time_period_warning:
      'The day time period and night time period need to cover the total time of the day for 24 hours.',
    reset_successfully: 'Reset successfully',
    region: 'Region',
    select_at_least_one_group: 'Select at least one group',
    node: 'Node',
    pods_location: 'Pods Location',
    pod_id: 'Pod ID',
    accelerometer: 'Accelerometer',
    senser: 'Senser',
    gain: 'Gain',
    offset: 'Offset',
    failed_to_connecte_smartz_service:
      'Failed to connect to Smartz<sup>®</sup> service',
    add_to_smartz_group_failed: 'Failed to add to smartz group service',
    retry: 'Retry',
    customization: 'Customization',
    customization_settings: 'Customization Settings',
    colors: 'Colors',
    font: 'Font',
    logo: 'Logo',
    login_background: 'Login Background',
    apply: 'Apply',
    theme: 'them',
    to_current_site: 'to current site',
    customize_theme_text:
      'Customize the look of the site. Feeling adventurous?',
    create_a_custom_theme: 'Create a custom theme',
    custom_theme: 'Custom Theme',
    preview: 'preview',
    reset_customization_settings:
      'All configurations have been restored to default',
    drag_the_logo_here: 'Drag the logo here',
    or: 'or',
    click_upload: 'click upload',
    only_image_files_can_be_uploaded: 'Only JPG / PNG files can be uploaded',
    the_size_of_the_uploaded_image_cannot_exceed:
      'The size of the uploaded image cannot exceed 2MB',
    please_sign_out_to_preveiw_effect:
      'After uploading, please sign out to preview effect',
    please_enter_theme_name: 'Please enter theme name',
    failed: 'Failed',
    add_pod: 'Add Pod',
    edit_pod: 'Edit Pod',
    filter_pod: 'Filter by pod serial number',
    filter_node: 'Filter by node, MAC address & room',
    delete_pod_warning: 'Deletion of pod is permanent. ',
    delete_theme_warning: 'Deletion of theme will be permanent.',
    apply_theme_warning:
      'Note: This operation will apply the custom settings to the current or below entered domain.',
    please_enter_domain_name: 'Please enter domain name',
    domain_name_incorrect: 'The domain name format is incorrect',
    apply_successfully: 'Applyed Successfully',
    location: 'Location',
    manufacturer_code: 'Manufacturer Code',
    node_mac_address: 'Node Mac Address',
    expired: 'Expired',
    please_select_location: 'Please select location',
    filter_patients: 'Filter Patients',
    monitor_patient: 'Monitor Patient',
    patient: 'Patient',
    room: 'Room',
    assign: 'Assign',
    unassign: 'Unassign',
    unassign_patient_permanent:
      'Please keep in mind that unassign the Patient is permanent.',
    you_able_to_unassign: `You're about to unassign`,
    node_mac_address_required: 'Node mac address is required',
    not_assigned: 'Not Assigned',
    assign_node_to: 'Assign node to',
    create_user: 'Create User',
    email_is_required: 'Email is required',
    created_successfully: 'Created Successfully',
    manage_patient_data: 'MANAGE PATIENT DATA',
    selected_patient: 'SELECTED PATIENT',
    archive_patient: 'ARCHIVE PATIENT',
    archive_patient_warning:
      'Archive Patient data. The Patient will no longer appear on the system until they are restored.',
    archive_patient_data: 'Archive Patient Data',
    restore_patient: 'Restore Patient',
    restore_patient_warning:
      'Restore archived data so that it can be viewed on this system.',
    archive_date: 'Archive Date',
    restore_patient_data: 'Restore Patient Data',
    delete_account: 'DELETE ACCOUNT',
    user_accounts: 'User Accounts',
    selected_site: 'Selected site',
    no_site: 'No Site',
    drag_the_login_background_here: 'Drag the login background here',
    drag_the_menu_background_here: 'Drag the menu background here',
    patient_data_privacy: 'PATIENT DATA PRIVACY',
    edit_theme: 'Edit Theme',
    drag_the_main_content_background_here:
      'Drag the main content background here',
    opacity_desc:
      'Opacity (Transparency of content suspended on the background)',
    menu_bg: 'Menu Background',
    main_content_bg: 'Main Content Background',
    background: 'Background',
    account: 'account',
    super_admin: 'super admin',
    help: 'Help',
    filter_by_user_name: 'filter by user name',
    drag_the_top_nav_background_here: 'Drag the top nav background here',
    apply_theme: 'Apply Theme',
    apply_to_current_domain: 'Apply to current domain',
    crop_image: 'Crop Image',
    enlarge: 'Enlarge',
    narrow: 'Narrow',
    left_rotation: 'Left Rotation',
    right_rotation: 'Right Rotation',
    remove_image: 'Remove Image',
    operation_area: 'Operation Area',
    preview_area: 'Preview Area',
    logo_shape: 'Logo shape',
    show_as_circle: 'Show as circle',
    history: 'History',
    status: 'Status',
    download: 'Download',
    export: 'Export',
    created_date: 'Created Date',
    next: 'Next',
    register: 'Register',
    back: 'Back',
    create_an_organisation: 'Create an Organization',
    please_enter_organisation_name: 'Please enter organization name',
    address: 'Address',
    please_enter_organisation_address: 'Please enter organization address',
    phone: 'Phone',
    please_enter_organisation_phone: 'Please enter organization phone',
    description: 'Description',
    add_facility: 'Add Facility',
    edit_facility: 'Edit Facility',
    facility: 'Facility',
    no_room: 'No Room',
    facility_name: 'Facility Name',
    add_room: 'Add Room',
    room_already_exists: 'Room already exists',
    home: 'home',
    signed_into: 'Signed into',
    please_select_an_organisation: 'Please select an organization',
    hello: 'Hello',
    useful_features: 'Useful features',
    attention: 'Attention',
    quick_actions: 'Quick actions',
    no_patient_warning:
      'There are no Patients to be monitored. Add Patients now to get started.',
    add_patient_quick_action_desc: 'Add a Patient to be monitored',
    welcome_to_the_group_dashboard: 'Welcome to the Group Dashboard',
    show_me_more: 'Show more',
    add: 'add',
    welcome_to_patient_management: 'Welcome to Patient Management',
    update_patient: 'Update Patient',
    update_patient_quick_action_desc: `Update Patient's details`,
    change_patient_products: `Change Patient's Products`,
    change_patient_products_quick_action_desc: 'Change product used by Patient',
    reassign_pod_to_patient: 'Reassign Pod to Patient',
    reassign_pod_quick_action_desc: `Change Patient's pod`,
    monitor_patient_with_a_node: 'Assign Node to Patient',
    monitor_patient_with_a_node_quick_action_desc: 'Review node of a Patient',
    welcome_to_the_administration_section:
      'Welcome to the Administration Section',
    invite_user: 'Invite User',
    invite_user_quick_action_desc: 'Invite a user to the system',
    remove_or_archive_patient: 'Remove/Archive Patient',
    remove_or_archive_patient_quick_action_desc:
      'Remove a Patient from dashboard',
    profile: 'Profile',
    not_monitored: 'not monitored',
    rounds: 'Rounds',
    //translate permissions list
    'Super Admin': 'Super Admin',
    Algorithms: 'Algorithms',
    Customisation: 'Customisation',
    Account: 'Account',
    'Roles & Permissions': 'Roles & Permissions',
    'Network Map': 'Network Map',
    'Network Utilisation': 'Network Utilisation',
    'Buildings & Rooms': 'Facilities & Rooms',
    Manufacturers: 'Manufacturers',
    Settings: 'Settings',
    Profile: 'Profile',
    Devices: 'Devices',
    Nodes: 'Nodes',
    'Pods Location': 'Pods Location',
    'Share Code': 'Share Code',
    Users: 'Users',
    'User Accounts': 'User Accounts',
    'Invite User': 'Invite User',
    Patients: 'Patients',
    'Monitor Patient': 'Monitor Patient',
    'Patient Data Privacy': 'Patient Data Privacy',
    Archive: 'Archive',
    Restore: 'Restore',
    'Patients Module': 'Patients Module',
    Export: 'Export',
    History: 'History',
    Report: 'Report',
    Monitor: 'Monitor',
    //translate permissions list
    time_zone: 'Time Zone',
    please_select_time_zone: 'Please select time zone',
    add_facility_and_room: 'ADD FACILITY & ROOM',
    filter_by_facility_name: 'filter by facility name',
    floor: 'Floor',
    please_enter_facility_name: 'Please enter facility name',
    please_enter_floor_name: 'Please enter floor name',
    please_enter_room_number: 'Please enter room number',
    facility_name_already_exists: 'Facility name already exists',
    floor_name_should_be_unique: 'Floor name should be unique',
    room_number_should_be_unique: 'Room number should be unique',
    add_manufacturer: 'Add Manufacturer',
    filter_by_manufacturer_code_or_name: 'filter by manufacturer code or name',
    enabled: 'Enabled',
    delete_manufacturer_warning: 'Deletion of manufacturer is permanent. ',
    please_enter_role_name: 'Please enter role name',
    please_choose_one_as_the_current_organization:
      'Please choose one as the current organization',
    display_name: 'Display Name',
    assign_roles: 'Assign Roles',
    remove: 'Remove',
    please_assign_a_role_to_the_user: 'Please assign a role to the user',
    send_invitation: 'send invitation',
    invitation_email_sent: 'Invitation email sent.',
    facility_and_Floor_and_Room: 'Facility, Floor, & Room',
    export_patient: 'export patient',
    export_patient_history_data: 'Export Patient history data',
    export_patient_data: 'Export Patient Data',
    export_report_success_text: `Patient's data export in progress. You will be notified via email when it is available. Check the progress on the files tab. `,
    select_patients: 'Select Patients',
    export_in_progress: 'Export in Progress',
    continue: 'continue',
    please_enter_patient_name: `Please enter Patient's name`,
    please_enter_patient_alias: `Please enter Patient's alias`,
    facility_and_room: 'Facility & Room',
    create_new: 'Create New',
    add_facility_and_floor_and_room: 'Add Facility, Floor, & Room',
    select_facility_floor_room: 'Select Facility, Floor, & Room',
    choose_one: 'Choose One',
    enter_manually: 'Enter Manually',
    pod_serial_number_format_incorrect:
      'Pod serial number format entered is incorrect.',
    add_a_manufacturer_to_continue: 'Add a manufacturer to continue',
    please_enter_subscription_code: 'Please enter subscription code',
    added_successfully: 'Added Successfully',
    select_a_patient: 'Select a Patient',
    assign_products: 'Assign Products',
    assign_pod: 'Assign Pod',
    assign_node: 'Assign Node',
    we_have_created_a_default_facility:
      'we have created a default facility, floor and room for your organization',
    if_you_want_edit_this_facility: `If you want to edit this Facility's information, tap`,
    or_you_can: 'or you can',
    already_registered: 'Already Registered',
    sign_up: 'Sign Up',
    create_account: 'Create Account',
    pod_and_diaper: 'Pod & Brief',
    pod_and_diaper_content: ` <p class="underline">Follow these steps to connect pod to brief:</p>
          <ul>
            <li>
            Line the three stripes on the Smart brief with the three gold pins on the Smart pod
            </li>
            <li>Clip pod onto the <span class="underline">front</span> of the Smart brief</li>
            <li>
            Green light flashing quickly for 3 seconds, then solid for 1 second = good connection
            </li>
            <li>
            No flashing green light after 20 seconds = no connection. Unclip and reclip the Smart pod
            </li>
            <li>If no light flashing with proper connection battery is dead</li>
          </ul>`,
    home_landing_slide1_title: 'Welcome to the Health Portal',
    home_landing_slide1_content: `
      <p>The Health Portal allows you to monitor your Patient's continence and wellbeing.</p>
      <p>Monitor groups of Patients to prioritize actions and provide individual centred care.</p>`,
    home_landing_slide2_title: 'Smart Brief Technology',
    home_landing_slide2_content: `
      <p>When a Smart pod is attached to a Smart brief it will transmit data via a network allowing the carer to monitor the Patient through the Health Portal.</p>
      <p>Once your Patient is allocated in the system, you will know at a glance when to change the brief and view historical data. You can also easily set goals and be notified of when to change the brief, your Patient's position, monitor fluid output, check surrounding temperature and potential falls.</p>`,
    home_landing_slide4_title: 'Add first Patient',
    home_landing_slide4_content: `
      <p>To begin, add a Patient by using the Quick Action button below and follow the prompts.</p>
      <p>The system will assist you throughout the Patient setup process.</p>`,
    home_landing_slide5_title: 'Quick Actions',
    home_landing_slide5_content: `
      <p>These allow you to access frequent actions such as adding a Patient.</p>
      <p>A wizard will guide you through all steps needed. </p>`,
    dashboard_landing_slide1_title: 'Welcome to the Group Dashboard',
    dashboard_landing_slide1_content: `
      <p>Monitor all your Patients on the Dashboard and know when your Patients need attention.</p>
      <p>Your workload can be reduced by following the system's visual prompts.</p>`,
    dashboard_landing_slide2_title: 'Welcome to the Group Dashboard',
    dashboard_landing_slide2_content: `<ul>
      <li>Icons are shown to indicate Patient's statuses</li>
      <li>There are two sections on the Dashboard, an <span class="underline">Action Required</span> and <span class="underline">Monitor</span> section</li>
      <li>To reduce workload and improve Patient care, tend to the <span class="underline">'Action Required'</span> icons with high priority</li>
    </ul>`,
    dashboard_landing_slide3_title: 'The Brief Statuses',
    dashboard_landing_slide3_content: `
      <p>The brief status and 'Time to Change' is represented by a traffic light system:</p>
      <ul>
        <li><span class="red-text"><span class="underline">Red</span> = change pad</span> i.e. wet brief at risk of leakage</li>
        <li><span class="yellow-text"><span class="underline">Yellow</span> = prepare to change brief</span> i.e. brief is reaching capacity</li>
        <li><span class="green-text"><span class="underline">Green</span> = no action</span> i.e. dry brief</li>
      </ul>`,
    dashboard_landing_slide4_title: 'Other Statuses',
    dashboard_landing_slide4_content: `
      <p>To ensure continuity of care, attend to all actions displayed on the Dashboard:</p>
      <ul>
        <li>'Lost Connection' symbol indicates that the Bluetooth connection has been lost and there may be loss of data.</li>
        <li>'Change Position' symbol indicates it is time to change Patient's position.</li>
      </ul>`,
    dashboard_landing_slide5_title: 'Optimize',
    dashboard_landing_slide5_content: `<p>Review the group dashboard notifications to optimize your daily Patient care.</p>`,
    dashboard_landing_slide6_title: 'Area Filters',
    dashboard_landing_slide6_content: `
      <p>The area filter is an optional feature allowing you to view a selected area on your dashboard of the facility. Use the area filters with caution, as it will hide existing Patients and only show the filter selections.</p>
      <p>To choose the new area filter: </p>
      <ol>
        <li>Select area dropdown</li>
        <li>Tap on 'New Area'</li>
        <li>Type the 'Area Filter Name'</li>
        <li>Select the building</li>
        <li>Tick the Area, Floor and Room numbers</li>
        <li>Review your filter selection in the filter summary box</li>
        <li>Tap to save this Area Filter</li>
        <li>Select area filter or 'Manage Areas' from the dropdown</li>
      </ol>
    `,
    home_landing_slide3_title: 'Pod & Brief',
    home_landing_slide3_content: `
    <ul>
      <li>Connect pod to brief</li>
      <li>Watch the green LED lights on the pod</li>
      <li>Receive updates of Patient statuses</li>
    </ul>`,
    patient_landing_slide1_title: 'Individual Dashboard',
    patient_landing_slide1_content: `
      <p>Selecting an individual Patient, a new dashboard will display the statuses of all features currently being monitored, including Smart pod and brief in use.</p>
      <p>Choose another Patient to be displayed from the drop down menu.</p>`,
    patient_landing_slide2_title: `Welcome to the Patient's section`,
    patient_landing_slide2_content: `
      <p>The Individual Dashboard indicates the current status of the Patient.</p>
      <p>The Charts section captures health trends.</p>
      <p>Specific goals can be set in the Goals section and notifications received.</p>`,
    patient_landing_slide3_title:
      'Access Individual Dashboard, Charts and Goals',
    patient_landing_slide3_content: `<p>On the left hand side of the Dashboard you are able to access the Patient, Charts and Goals section.</p>`,
    patient_landing_slide4_title: 'Patient / Individual Dashboard',
    patient_landing_slide4_content: `
      <ul>
        <li>Each Patient has their own Individual Dashboard</li>
        <li>Delve deeper into the individual status of your Patient</li>
        <li>Switch between Patients by selecting from the dropdown arrow</li>
      </ul>`,
    patient_landing_slide5_title: 'Charts',
    patient_landing_slide5_content: `
      <p>There are various charts enabling you to view and interpret data, these include:</p>
      <ul>
        <li>Voiding chart</li>
        <li>Pad Fill Profile</li>
        <li>Position chart.</li>
      </ul>
      <p>You can print and share these in order to review and adjust your Patient's care.</p>`,
    patient_landing_slide6_title: 'Goals',
    patient_landing_slide6_content: `
      <p>To further enhance the care of your Patient, specific goals can be set. These include:</p>
      <ul>
        <li>Body Position</li>
        <li>Skin Care</li>
        <li>Pad Fill Profile</li>
        <li>Temperature</li>
        <li>Falls.</li>
      </ul>`,
    common_help_content: `
      <ul>
        <li>Choose which Patient to view by simply using the dropdown menu.</li>
      </ul>`,
    chart_common_slide_content: `
      <ul>
        <li>By selecting the date range a maximum of 7-days can be displayed.</li>
      </ul>`,
    voiding_chart_slide1_content: `
      <ul>
        <li>The voiding chart will provide a holistic view of your Patients voiding history.</li>
        <li>Real time data is shown on the voiding chart when using the Smartz<sup>®</sup> system.</li>
        <li>This chart allows you to switch between viewing the pad cycle or the overview of voiding events.</li>
      </ul>`,
    voiding_chart_slide4_content: `
      <ul>
        <li>Icons can be filtered by selection.</li>
        <li>The legend beneath the voiding chart displays the icons shown on the chart.</li>
        <li>Tap on 'chart filters' to select or deselect the icons you want to view.</li>
      </ul>`,
    voiding_chart_slide5_content: `
      <p>By viewing this chart, you are able to:</p>
      <ul>
        <li>identify potential times the Patient could be successfully toileted</li>
        <li>if the brief was changed within an acceptable time period</li>
        <li>the number of pad changes over the period</li>
        <li>share and print your chart.</li>
      </ul>`,
    smartz_events_slide1_content: `
      <ul>
        <li>The Events Chart displays all events for brief, pod, goal and networking statuses.</li>
      </ul>`,
    pad_fill_profile_chart_slide1_content: `
      <ul>
        <li>The 'Total Daily Profile' displays the total amount of fluid voided into the pad over a 24 h period.</li>
        <li>The daily output into the brief is shown above each drop.</li>
      </ul>`,
    pad_fill_profile_chart_slide4_content: `
      <ul>
        <li>The icon on the right indicates the 'Average' volume output over the period of days selected.</li>
        <li>Toggle to see either the 'Day' and 'Night' profiles separately.</li>
        <li>The chart indicates if a Pad Fill Profile goal has been set or triggered.</li>
        <li>Choose to setup the goal if required.</li>
      </ul>`,
    pad_fill_profile_chart_slide5_content: `
      <ul>
        <li>The total daily profile shows the total amount of fluid that has been voided into the brief during a 24 h period.</li>
        <li>If the Patient has a reduction in urine output, it may be an indicator to increase hydration.</li>
        <li>Share and print your chart.</li>
      </ul>`,
    body_position_chart_slide1_content: `
      <ul>
        <li>The chart displays the length of time in a body position over a selected number of days.</li>
        <li>To see more detail, hover over the chart.</li>
      </ul>`,
    body_position_chart_slide4_content: `
      <ul>
        <li>Tap on 'chart filters' to select or deselect the positions you want shown.</li>
        <li>The chart highlights if a Body Position goal has been set.</li>
        <li>Tap to setup the goal.</li>
      </ul>`,
    body_position_chart_slide5_content: `
      <ul>
        <li>If you have a Patient who is prone to skin breakdown / pressure injury, by setting the goal you will be notified of the time to change the Patient's position.</li>
        <li>When 'print' is selected the positions and the time periods are listed in additional detail. </li>
      </ul>`,
    goal_common_slide_content: `
      <ul>
        <li>Check the light bulb section for more detail.</li>
      </ul>`,
    body_position_goal_help_title: 'Body Position Goal',
    body_position_goal_slide1_content: `
      <ul>
        <li>By setting the goal the carer will be notified of the time to change the Patient's position.</li>
        <li>Use this goal if you have a Patient who is prone to skin breakdown / pressure injury.</li>
        <li>Reducing time in one position could assist to alleviate pressure injury.</li>
      </ul>`,
    body_position_goal_slide2_content: `
      <ul>
        <li>Choose which Patient to view by simply using the dropdown menu.</li>
        <li>Move the slider to choose the maximum length of time you want your Patient to be in the one position either during the day and / or night.</li>
        <li>Tap to save the goal.</li>
      </ul>`,
    body_position_goal_slide3_content: `
      <ul>
        <li>You have now selected the maximum length of time for your Patient to be in one position and you will be notified in the 'Action Required' section when to change.</li>
      </ul>`,
    skin_management_goal_help_title: 'Skin Management Goal',
    skin_management_goal_slide1_content: `
      <ul>
        <li>Changing the brief more regularly could help keep the Patient's skin dry and reduce skin irritations.</li>
      </ul>`,
    skin_management_goal_slide2_content: `
      <ul>
        <li>Choose which Patient to view by simply using the dropdown menu.</li>
        <li>Move the slider to select the maximum length of time you want your Patient to spend in a brief.</li>
        <li>Tap to save the goal.</li>
      </ul>`,
    skin_management_goal_slide3_content: `
      <ul>
        <li>You will now be notified in the 'Action Required' section when to change the Patient's brief.</li>
      </ul>`,
    pod_temperature_goal_help_title: 'Surrounding Pod Temperature',
    pod_temperature_goal_slide1_content: `
      <ul>
        <li>This goal allows you to set the minimum / maximum surrounding pod temperature.</li>
        <li>Set this goal if you have concerns about your Patient's temperature fluctuation.</li>
      </ul>`,
    pod_temperature_goal_slide2_content: `
      <ul>
        <li>Choose which Patient to view by simply using the dropdown menu.</li>
        <li>To be notified of any change in temperature surrounding the pod, move the slider to choose the minimum and maximum temperatures.</li>
        <li>Tap to save the goal.</li>
      </ul>`,
    pod_temperature_goal_slide3_content: `
      <ul>
        <li>You will now be notified in the 'Action Required' section when the surrounding pod temperature is outside the set range.</li>
      </ul>`,
    pad_fill_profile_goal_help_title: 'Pad Fill Profile Goal',
    pad_fill_profile_goal_slide1_content: `
      <ul>
        <li>This goal allows you to set up the minimum / maximum voiding volume into the brief if you are concerned that your Patient has a low urine output.</li>
      </ul>`,
    pad_fill_profile_goal_slide2_content: `
      <ul>
        <li>Choose which Patient to view by simply using the dropdown menu.</li>
        <li>Move the slider to select the preferred volume for day and / or night.</li>
        <li>Tap to save the goal.</li>
      </ul>`,
    pad_fill_profile_goal_slide3_content: `
      <ul>
        <li>You will now be notified in the 'Action Required' section when your Patient's output volume into the brief is outside the set range.</li>
      </ul>`,
    fall_detection_goal_help_title: 'Fall Detection Goal',
    fall_detection_goal_slide1_content: `
      <ul>
        <li>This goal will notify you if your Patient has fallen.</li>
      </ul>`,
    fall_detection_goal_slide2_content: `
      <ul>
        <li>Choose which Patient to view by simply using the dropdown menu.</li>
        <li>Move the slider to the ON position to activate the goal.</li>
        <li>By default, the 'Time in Position' is turned on. </li>
        <li>Tap to save the goal.</li>
      </ul>`,
    fall_detection_goal_slide3_content: `
      <ul>
        <li>If a fall has occurred, a flashing icon will be displayed in the 'Action Required' section.</li>
        <li>Silencing the fall in the 'Individual Dashboard' will remove the icon from the main dashboard.</li>
      </ul>`,
    voiding_chart_help_dialog_title: 'Using the Voiding Chart',
    pad_fill_profile_chart_help_dialog_title: 'Using the Pad Fill Profile',
    position_chart_help_dialog_title: 'Using the Body Position Chart',
    pad_fill_profile_goal_help_dialog_title: 'Setting up Pad Fill Profile Goal',
    skin_care_goal_help_dialog_title: 'Setting up Skin Care Management Goal',
    position_goal_help_dialog_title: 'Setting up Body Position Goal',
    temperature_goal_help_dialog_title:
      'Setting up Surrounding Pod Temperature Goal',
    fall_detection_goal_help_dialog_title: 'Setting up Falls Detection Goal',
    invite_user_quick_action_desc_for_home_landing:
      'Invite a care provider to join this organization',
    archived_successfully: 'Archived Successfully',
    verification_passed: 'Verification Passed',
    verification_failed: 'Verification Failed',
    verify_error_msg_801:
      'Your invitation has expired or is no longer valid. To request another invitation, contact the admin of the organization.',
    verify_error_msg_802:
      'Your invitation is not valid for this user. If you were logged in as a different user prior to accepting this invitation. Please log out and try again.',
    verify_error_msg_803: 'User not found.',
    verify_error_msg_804: 'Invitation code not found.',
    verify_error_msg_805:
      'You are already a member of the organization you want to join.',
    verify_success_msg: 'Welcom to the new organization.',
    verify_error_msg_not_sign_in: `Please sign in to join the organization. <br/> If you don't have an account, please sign up first.`,
    verify_error_msg_620: 'The code is invalid or has expired',
    verify_error_msg_622: `Couldn't join organization. The invitation code is not valid for this email address.`,
    failed_to_get_chart_data: 'Chart data could not be sent.',
    filter: 'Filter',
    please_select_facility_first: 'Please select facility first',
    areas: 'Area(s)',
    floors: 'Floor(s)',
    new_area: 'New Area',
    manage_areas: 'Manage Areas',
    show_all_facilities: 'Show All Facilities',
    show_all_areas: 'Show All Areas',
    new_area_filter: 'New Area Filter',
    area_filter_name: 'Area Filter Name',
    area: 'Area',
    please_enter_area_filter_name: 'Please enter area filter name',
    please_select_facility: 'Please select facility',
    please_select_floor_and_room: 'Please select floor and room',
    please_select_organisation: 'Please select organization',
    filter_summary: 'Filter Summary',
    show_patients_from: 'Show Patients from',
    in: 'in',
    and: 'and',
    belonging_to: 'belonging to',
    select_an_area: 'Select an Area',
    manage_area: 'Manage Area',
    please_select_area_filter: 'Please select area filter',
    delete_area: 'Delete Area',
    keep_in_mind_delete_area: 'Deletion of area will be permanent. ',
    facility_information: 'Facility Information',
    floor_information: 'Floor Information',
    room_information: 'Room Information',
    number_of_floors: 'Number of Floors',
    please_enter_number_of_floors: 'Please enter number of floors',
    number_of_rooms: 'Number of Rooms',
    please_enter_number_of_rooms: 'Please enter number of rooms',
    add_floor: 'Add Floor',
    remove_floor: 'Remove Floor',
    remove_room: 'Remove Room',
    select_area_warning: `Area and floor can't be selected at the same time. <br/>Select only one.`,
    manage_area_filter: 'Manage Area Filter',
    no_area: 'No Area',
    there_are_no_patient_to_manage: 'There are no Patients to manage.',
    default_themes: 'Default themes',
    custom_themes: 'Custom themes',
    background_color: 'Background Color',
    top_navigation_background_color: 'Top Navigation Background Color',
    top_nav_text_color: 'Top Nav Text Color',
    top_nav_active_text_color: 'Top Nav Active Text Color',
    sidebar_background_color: 'Sidebar Background Color',
    sidebar_active_block_background_color:
      'Sidebar Active Block Background Color',
    sidebar_text_color: 'Sidebar Text Color',
    sidbar_active_block_text_color: 'Sidbar Active Block Text Color',
    card_title_background_color: 'Card Title Background Color',
    card_title_text_color: 'Card Title Text Color',
    card_body_background_color: 'Card Body Background Color',
    card_button_color: 'Card Button Color',
    room_number: 'Room Number',
    verify_invitation: 'VERIFY INVITATION',
    well_done: 'Well Done!',
    you_have_updated_the_patient: `You have updated the Patient's details.`,
    you_have_created_the_patient:
      'You have added a Patient who can be viewed on the group dashboard.',
    tell_me_more: 'Tell me more',
    registered_pods: 'Registered Pods',
    registered_nodes: 'Registered Nodes',
    select: 'Select',
    start: 'Start',
    end: 'End',
    floor_name: 'Floor Name',
    sign_in_failed: 'Sign In Failed',
    skin_care_goal_title: 'Time in Pad',
    'Event Chart': 'Smartz Event Chart',
    account_information: 'Account Information',
    given_name: 'Given Name',
    surname: 'Surname',
    please_enter_pod_serial_number: 'Please enter pod serial number',
    manufacturer_subscription_code: `Manufacturer's Subscription Code`,
    remove_node_mac_address: 'Remove node mac address',
    link_a_node_mac_address: 'Link a node mac address',
    export_data: 'Export Data',
    available_files: 'Available Files',
    export_patient_data_desc:
      'Click the following button to export the historical data of',
    dry_diaper: 'Dry Brief',
    wet_diaper: 'Wet Brief',
    change_diaper: 'Change Brief',
    external_humidity: 'External Humidity',
    smartz_events: 'Smartz<sup>®</sup> Events',
    smartz_events_chart_email_content:
      'The emailed Events Chart is ready for you to review.',
    reposition: 'Reposition',
    fall: 'fall',
    cycle: 'Cycle',
    pad_cycle: 'pad cycle',
    off_body: 'off-body',
    pad_status_legend: 'Pad Status',
    analysing_diaper_legend: 'Analyzing Brief',
    dry_wet_change_diaper: 'dry/wet/change brief',
    pod_status: 'Pod Status',
    goal_status: 'Goal Status',
    diaper_removed_legend: 'Brief Removed',
    time_to_change_legend: 'time-to-change',
    out_of_range_legend: 'out-of-range',
    diaper_not_selected: 'Brief Not Selected',
    duration: 'Duration',
    small_void: 'Small Void',
    medium_void: 'Medium Void',
    large_void: 'Large Void',
    view_mode: 'View Mode',
    voids_only: 'voids only',
    void_event_size: 'void event size',
    pad_start: 'Pad Start',
    pad_end: 'Pad End',
    exceed_goal_time: 'Exceed goal time',
    reclip: 'reclip',
    unstable_readings: 'Unstable Readings',
    not_selected: 'Not Selected',
    analysing: 'Analyzing',
    create_organisation: 'Create Organization',
    all_times_are_in: 'All times are in',
    failed_to_get_goal_settings: 'Failed to get goal settings',
    next_steps: 'Next Steps',
    video: 'Video',
    monitor_warning:
      'Monitoring is not available because there is no Smartz<sup>®</sup> pod assigned to',
    find_further_information: 'Find further information',
    here: 'here',
    savePatientPodErrMsg: `The provided pod serial number doesn't exist in this organization.`,
    savePatientNodeErrMsg: `The provided node mac address doesn't exist in this organization.`,
    already_registered_desc:
      'Please sign in using your username and password you have registered with initially.',
    create_account_desc:
      'Please provide a username and password to create a user account and in order to access the site.',
    signing_in: 'Signing in',
    signing_out: 'Signing out',
    welcome: 'Welcome',
    top: 'Top',
    facility_or_building: 'Facility / Building',
    keep_at_least_one_facility: 'Keep at least one facility',
    keep_at_least_one_floor: 'Keep at least one floor',
    keep_at_least_one_room: 'Keep at least one room',
    rename: 'Rename',
    domain_name: 'Domain Name',
    subscription_code: 'Subscription Code',
    events: 'Events',
    no_pods_text: 'There are no pods registered in this organization.',
    no_nodes_text: 'There are no nodes registered in this organization.',
    confirm_deletion: 'Confirm deletion.',
    confirm_archive: 'Confirm archive.',
    account_deletion: 'Account Deletion',
    delete_account_warning:
      'Deletion of user account and personal data is permanent.',
    deletion: 'Deletion',
    restoring_patient: 'Restoring Patient',
    font_family: 'Font Family',
    font_size: 'Font Size',
    font_color: 'Font Color',
    main_title: 'Main Title',
    title: 'Title',
    small_title: 'Small Title',
    body_text: 'Body Text',
    body_text_small: 'Body Text (small)',
    supplementary_text: 'Supplementary Text',
    primary_text: 'Primary Text',
    regular_text: 'Regular Text',
    secondary_text: 'Secondary Text',
    placeholder_text: 'Placeholder Text',
    top_nav_background: 'Top Nav Background',
    edit_facility_and_floor_and_room: 'Edit Facility, Floor, & Room',
    please_select_buildings: 'Please select buildings',
    please_select_floors: 'Please select floors',
    please_select_rooms: 'Please select rooms',
    facility_setup: 'Facility Setup',
    apply_to_entered_domain: 'Apply to entered domain',
    view_a_patient_by_selecting_from_drop_down_menu:
      'View a Patient by selecting from drop down menu.',
    monitoring: 'monitoring',
    silencing: 'Silencing',
    fall_detection: 'fall detection',
    wetness: 'wetness',
    pod: 'Pod',
    diaper: 'Brief',
    time_in_diaper: 'Time in Brief',
    setup_area_filter_desc: 'Follow these steps to setup a new area filter.',
    max_time_in_pad: 'Max time in pad',
    max_time_in_pos: 'Max time in pos',
    change_in: 'Change in',
    not_monitoring: 'Not Monitoring',
    exceed_allowed_time: 'Exceed Allowed time',
    Pseudonymized: 'Pseudonymized',
    Anonymized: 'Anonymized',
    pseudonymized_permission_warning:
      'Patient pseudonymized permission and patient edit permission cannot be selected at the same time. Please select one of them.',
    anonymized_permission_warning:
      'Patient anonymized permission and patient edit permission cannot be selected at the same time. Please select one of them.',
    reporting_page_desc:
      'The following information about your organisation will be used in Reporting',
    baseline_trial_periods: 'BASELINE/ TRIAL PERIODS',
    rounds_shifts: 'ROUNDS / SHIFTS',
    you_are_about_to_remove_this_item: 'You are about to remove this item',
    add_round: 'Add Round / Shift',
    edit_round: 'Edit Round / Shift',
    baseline: 'Baseline',
    trial: 'Trial',
    range: 'Range'
  },
  country: 'Canada',
  language: 'Canadian-English',
  abb_name: 'ca'
}
